export default {
  footerText: 'Powered by Kustomer',
  footerNavigationChat: 'Chat',
};
